import classNames from "classnames";
import { delayOnOutsideClick } from "helpers";
import { createLogger } from "logging";
import { PropsWithChildren, ReactNode, useRef } from "react";
import { useOnClickOutside } from "usehooks-ts";

const logger = createLogger("HeaderMenuDropdown");

interface HeaderMenuDropdownProps extends PropsWithChildren {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  trigger: ReactNode;
  id: string;
  buttonClassName?: string;
}

export const HeaderMenuDropdown: React.FC<HeaderMenuDropdownProps> = ({
  id,
  isOpen,
  setIsOpen,
  trigger,
  buttonClassName,
  children,
}) => {
  const outsideClickRef = useRef<HTMLDivElement>(null!);
  useOnClickOutside(outsideClickRef, () => {
    delayOnOutsideClick(logger, isOpen, setIsOpen);
  });

  const buttonClass = classNames("btn", "btn-link", "dropdown-toggle", buttonClassName, isOpen ? "show" : "");
  const menuClass = classNames("dropdown-menu", isOpen ? "show" : "");

  return (
    <div className="sbb-header-nav-item" ref={outsideClickRef}>
      <div className="dropdown" onClick={() => setIsOpen(!isOpen)} aria-hidden="true">
        <button className={buttonClass} type="button" id={`${id}-button`} aria-haspopup="true" aria-expanded={isOpen}>
          {trigger}
        </button>
        <div className={menuClass} aria-labelledby={id}>
          <div className="dropdown-inner">{children}</div>
        </div>
      </div>
    </div>
  );
};
